import React, { createContext, useContext, useEffect, useState } from "react";
import { UserProfile } from "./models/UserProfile";
import { User } from "./models/User";
import { estateApi, } from "./apis";
import { useAuthContext } from "AuthContextWrapper";
import { UserProfileAPI } from "apis/UserProfileAPI";

interface Props {
  children: JSX.Element;
}

interface EstateUserContextInterface {
  usersInActiveEstate?: User[],
  setUsersInActiveEstate: (users: User[]) => void,
  updateOtherUserProfile: (user: UserProfile) => Promise<UserProfile | undefined>,
  addUserToEstate: (userId: number) => Promise<boolean>,
}
const EstateUserContext = createContext<EstateUserContextInterface | null>(null);

export const EstateUserContextWrapper = ({ children }: Props): JSX.Element => {
  const { activeEstate } = useAuthContext()
  const [usersInActiveEstate, setUsersInActiveEstate] = useState<User[] | undefined>()

  // once we have an active estate, get users in that estate
  useEffect(() => {
    (async () => {
      if (!activeEstate?.id) {
        return
      }

      const users = await estateApi.fetchUsersInEstate(activeEstate.id)
      setUsersInActiveEstate(users || [])
    })();
  }, [activeEstate?.id]);

  async function updateOtherUserProfile(profile: UserProfile): Promise<UserProfile | undefined> {
    return await UserProfileAPI.updateOtherUserProfile(profile.toJSON())
  }

  async function addUserToEstate(userId: number): Promise<boolean> {
    if (!activeEstate || !activeEstate.id) {
      console.error("not done loading active estate")
      return false
    }

    return await estateApi.addUserToEstate(activeEstate.id, userId)
  }

  return (
    <EstateUserContext.Provider
      value={{
        usersInActiveEstate,
        updateOtherUserProfile,
        addUserToEstate,
        setUsersInActiveEstate,
      }}
    >
      {children}
    </EstateUserContext.Provider>
  );
};

export function useEstateUserContext(): EstateUserContextInterface {
  const estateUserContext = useContext(EstateUserContext)
  if (!estateUserContext) {
    throw new Error("the component calling this estate user context is not nested within a context provider")
  }

  return estateUserContext
}